/** Success cases and proof in production, from the API contract (`src/api/generated`). */

import type {
  CaseCreateIn,
  CaseOutOutput,
  CasesOutOutput,
  MetricIn,
  MetricOutOutput,
  ProofMetricOutput,
  ProofOutOutput,
} from '../generated/schemas';

export type { CaseCreateIn, CaseUpdateIn, MetricIn } from '../generated/schemas';

export type CaseType = CaseCreateIn['type'];
export type CaseStatus = CaseCreateIn['status'];
export type Provenance = MetricIn['provenance'];

export const CASE_TYPES: { value: CaseType; label: string }[] = [
  { value: 'client', label: 'Client' },
  { value: 'benchmark', label: 'Benchmark' },
];

export const CASE_STATUSES: { value: CaseStatus; label: string }[] = [
  { value: 'live', label: 'Live' },
  { value: 'pilot', label: 'Pilot' },
  { value: 'pipeline', label: 'Pipeline' },
  { value: 'closed', label: 'Closed' },
];

export const PROVENANCES: { value: Provenance; label: string }[] = [
  { value: 'client_measured', label: 'Client measured' },
  { value: 'self_measured', label: 'Self measured' },
  { value: 'expected', label: 'Expected' },
];

/** The four narrative fields of a case, in reading order. */
export const CASE_TEXT_FIELDS = [
  { key: 'situation', label: 'Situation' },
  { key: 'objective', label: 'Objective' },
  { key: 'approach', label: 'Approach' },
  { key: 'achievements', label: 'Achievements' },
] as const;

export type CaseTextKey = (typeof CASE_TEXT_FIELDS)[number]['key'];

/** A metric as the case views show it: saved (`MetricOut`) or as the editor will send it (`MetricIn`). */
export type CaseMetric = MetricOutOutput | MetricIn;

export type CaseOut = CaseOutOutput;
export type CaseListOut = CasesOutOutput;
export type ProofMetric = ProofMetricOutput;
/** `AssetOut.proof`: computed per request from the linked cases, filtered by audience. */
export type ProofOut = ProofOutOutput;
